import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { Option } from '../../types/option'

import { Controller, useFormContext } from 'react-hook-form'
import { MedicalRecordFormData } from '../../medicalRecordSchema'
import { CustomRadioButton } from '../CustomRadioButton'
import * as S from './styles'
import { RadioButtonErrorWrapper } from '../RadioButtonErrorWrapper'

const radioOptions: Option[] = [
  { id: 'other-symptoms-impact-on-work-life-high', name: 'Alto' },
  { id: 'other-symptoms-impact-on-work-life-medium', name: 'Médio' },
  { id: 'other-symptoms-impact-on-work-life-low', name: 'Baixo' },
  { id: 'other-symptoms-impact-on-work-life-none', name: 'Nenhum' },
]

export function OtherSymptomsImpactOnWorkLife(): JSX.Element {
  const {
    control,
    formState: { errors },
  } = useFormContext<MedicalRecordFormData>()

  const errorMessage = errors.symptoms_impact_on_work_life?.message
  const hasErrorMessage = Boolean(errors.symptoms_impact_on_work_life?.message)

  return (
    <S.OtherSymptomsImpactOnWorkLifeContainer>
      <Typography weight='bolder' variant='content2'>
        Qual o impacto destes sintomas na rotina de trabalho? *
      </Typography>
      <RadioButtonErrorWrapper errorMessage={errorMessage}>
        <S.RadioButtonOptions>
          {radioOptions.map((option) => (
            <Controller
              key={option.id}
              control={control}
              name='symptoms_impact_on_work_life'
              render={({ field }) => (
                <CustomRadioButton
                  {...field}
                  key={option.id}
                  id={option.id as string}
                  onChange={() => field.onChange(option.id)}
                  label={
                    <Typography variant='content2'>{option.name}</Typography>
                  }
                  hasError={hasErrorMessage}
                />
              )}
            />
          ))}
        </S.RadioButtonOptions>
      </RadioButtonErrorWrapper>
    </S.OtherSymptomsImpactOnWorkLifeContainer>
  )
}
